import Openpop from "./Openpop";
import './Index.css';

export { Openpop };
export default Openpop;